import { combineReducers } from 'redux';

// reducer import
import customizationReducer from './customizationReducer';
import investorDetailsReducer from './investorDetailsReducer';
import roleDetailsReducer from './roleDetailsReducer';
import permissionsReducer from './permissionsReducer';
import { RESET_STATE } from './actions';
import progressReducer from './progressReducer';

// ==============================|| COMBINE REDUCER ||============================== //

const appReducer = combineReducers({
    customization: customizationReducer,
    investorDetails: investorDetailsReducer,
    roleDetails: roleDetailsReducer,
    permissions: permissionsReducer,
    progress: progressReducer,
});

const reducer = (state, action) => {
    if (action.type === RESET_STATE) {
        state = {
            customization: { opened: false },
            investorDetails: { data: null, investor_types: [] },
            roleDetails: {
                role: null
            },
            permissions: { template: null, userPermissions: null },
            progress: {
                progressData: null,
                requiredFields: [],
                completionPercentage: 0,
                round_id: null
            }
        }; // Set state to undefined to reset all reducers
    }
    return appReducer(state, action);
};

export default reducer;
